export const kiosk = {
  seo: {
    title: 'Bestelzuil voor restaurants | Bistroo',
    description: 'De Bistroo bestelzuil laat gasten zelfstandig bestellen op locatie. Minder wachtrij, meer omzet. Vraag naar de mogelijkheden.',
  },
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'bestelzuil',
      pt3: 'die jouw omzet laat groeien op autopilot',
    },
    description:
      'De Bistroo Kiosk laat gasten op eigen tempo bestellen, waardoor jouw personeel vrijkomt voor wat echt telt. Meer bestellingen, hogere orderwaarden en kortere wachtrijen zonder extra inzet.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Meer omzet, kortere wachttijden',
      text: 'Een selfservice-kiosk verhoogt de gemiddelde orderwaarde met tot wel 25%, doordat gasten de tijd nemen om te bestellen en eerder geneigd zijn up-sell suggesties te accepteren. Tegelijkertijd verwerkt je team meer bestellingen in minder tijd, zonder extra personeel aan de kassa.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Interactief design in jouw eigen huisstijl',
      text: 'Personaliseer de kioskzuil volledig in de kleuren en uitstraling van jouw merk. Van het welkomstscherm tot de orderbevestiging, alles sluit naadloos op de huisstijl van jouw restaurant. Zo wordt de Bistroo Kiosk een echte Eye-catcher die perfect past binnen jouw concept.',
      cta: '',
    },
    paragraph_3: {
      title: 'Snel, overzichtelijk en georganiseerd bestellen',
      text: 'Elke bestelling via de Bistroo Kiosk krijgt automatisch een ordernummer en bon, zodat afhalen eenvoudig is voor klanten en overzichtelijk voor personeel. Een soepele bestelervaring voor zowel individuele locaties als enterprise ketens.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Volledig beheer via de Bistroo Manager',
      text: 'Het laatste wat je als restaurant- of foodshopeigenaar wilt, is iemand moeten bellen om je menu te wijzigen. Wij geven je volledige controle over je data, producten, klanten en bestellingen!',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Zelfstandig bestellen, minder druk aan de kassa.',
        text: 'Gasten bestellen op eigen tempo via het touchscreen. Jouw personeel houdt meer tijd over voor service, bereiding en kwaliteit.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel de kiosk eenvoudig aan je kassasysteem, keukenscherm of andere tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Slimme upselling.',
        text: 'Stel automatische suggesties in bij elke bestelling en verhoog de gemiddelde orderwaarde moeiteloos.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Omzet verhogen.',
        text: 'Restaurants zien gemiddeld tot 25% meer omzet na de introductie van een bestelzuil.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Promoties en loyaliteit.',
        text: 'Stel kortingen, acties en loyaliteitsbeloningen in die direct zichtbaar zijn op de kiosk.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Sinds de introductie van de Bistroo Kiosk zijn de wachtrijen merkbaar korter en bestellen gasten meer dan voorheen. Ons personeel heeft nu eindelijk tijd voor echte gastvrijheid."',
    cta: 'Lees het volledige verhaal',
    name: 'Thomas Hendriks',
    job_title: 'Eigenaar La Bella Cucina',
  },
  faq: {
    title_pt1: 'Alles over de',
    title_pt2: 'Bistroo Kiosk',
    items: [
      { q: 'Wat is de Bistroo Kiosk en voor wie is hij geschikt?', a: 'De Bistroo Kiosk is een selfservice-bestelzuil voor restaurants, foodshops en horecaketens. Gasten bestellen zelfstandig via een touchscreen, wat zorgt voor kortere wachtrijen en een hogere gemiddelde orderwaarde.' },
      { q: 'Hoe installeer ik de bestelzuil?', a: 'De kiosk is plug-and-play. Na levering zet je hem aan, verbindt hem met je wifi en is hij klaar voor gebruik. Bistroo begeleidt je bij de initiële setup en koppeling met je bestaande systemen.' },
      { q: 'Kan ik de kiosk aanpassen in mijn eigen huisstijl?', a: 'Absoluut. Je personaliseert het welkomstscherm, de kleuren en de uitstraling volledig naar jouw merk. Van de eerste afbeelding tot de orderbevestiging, alles sluit naadloos aan op je huisstijl.' },
      { q: 'Hoe worden bestellingen van de kiosk verwerkt?', a: 'Elke kiosk-bestelling krijgt automatisch een ordernummer en bon. De bestelling wordt direct doorgestuurd naar de keukenprinter of het kassasysteem, net als een gewone online bestelling.' },
      { q: 'Welke betaalmethoden ondersteunt de kiosk?', a: 'De Bistroo Kiosk ondersteunt pin (contactloos en chip) en mobiele betaalmethoden zoals Apple Pay en Google Pay. Contant betalen is optioneel afhankelijk van jouw inrichting.' },
      { q: 'Hoe werkt de upselling op de kiosk?', a: 'Je stelt in de Bistroo Manager automatische suggesties in per product of categorie. Op het juiste moment in het bestelproces krijgt de gast een relevante suggestie te zien, wat de gemiddelde orderwaarde merkbaar verhoogt.' },
      { q: 'Is de kiosk te koppelen aan mijn kassasysteem?', a: 'Ja. De Bistroo Kiosk integreert met alle gangbare kassasystemen. Bestellingen stromen automatisch door naar je keuken of kassa, zonder handmatige tussenkomst.' },
      { q: 'Hoe beheer ik het menu op de kiosk?', a: 'Je menu op de kiosk is altijd gesynchroniseerd met de Bistroo Manager. Pas een prijs aan, zet een product op inactief of voeg een actie toe en de kiosk toont dit direct.' },
      { q: 'Wat zijn de kosten van de Bistroo Kiosk?', a: 'De kosten bestaan uit de huur of aanschaf van het hardwareapparaat plus een maandelijks softwarebedrag. Neem contact op via bistroo.nl voor een offerte op maat voor jouw situatie.' },
      { q: 'Hoeveel meer omzet genereert een bestelzuil gemiddeld?', a: 'Restaurants die de Bistroo Kiosk introduceren zien gemiddeld tot 25% meer omzet per bestelling. Gasten nemen meer tijd om te bestellen en zijn eerder geneigd extras te kiezen wanneer ze geen tijdsdruk ervaren door een wachtrij.' },
    ],
  },
}
